import { ThemeProvider, createTheme } from "@material-ui/core/styles"
import Onboarding from "./views/onboarding"
import { mainTheme } from "./muiTheme"

const muiTheme = createTheme(mainTheme)
const App = () => (
  <ThemeProvider theme={muiTheme}>
    <Onboarding />
  </ThemeProvider>
)

export default App;
